// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loadmore-wrap[data-v-f7d83a22]{width:100%;display:flex;flex-direction:column}.loadmore-wrap .mu-appbar[data-v-f7d83a22]{width:100%}.loadmore-content[data-v-f7d83a22]{flex:1;overflow:auto;-webkit-overflow-scrolling:touch}.mu-paper.mu-paper-round.mu-elevation-1[data-v-f7d83a22]{box-shadow:none}.container[data-v-f7d83a22],.loadmore-content.container[data-v-f7d83a22]{padding:0}", ""]);
// Exports
module.exports = exports;
